var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-layout',{staticClass:"create-notification",attrs:{"max-width":"1515px","title":"Центр уведомлений","back-route":"/notification-center/notifications"}},[_c('edited-notification',{attrs:{"notification":_vm.notification}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }